import type { ReactNode } from 'react'
import { useContext } from 'react'

import { createSharedContext } from '@twistopayments/design-system/utils'

/**
 * Context
 */

const Context = createSharedContext<number | undefined>('components/molecules/stepper/stepper/step-index.context#0', undefined)

/**
 * Provider
 */

type Props = {
  children: ReactNode
  index: number
}

export const StepIndexProvider = ({ children, index }: Props) => (
  <Context.Provider value={index}>{children}</Context.Provider>
)

/**
 * Hook
 */

export const useStepIndex = () => {
  const context = useContext(Context)

  if (context === undefined) {
    throw new Error('useStepIndex must be used within a StepIndexProvider')
  }

  return context
}
